import { useQuery } from "@tanstack/react-query";
import { outgoingRepository } from "../repositories/outgoing.repository";

export const outgoingByIdQueryKey = (id: string) => ["outgoing", id, "detail"];

export function useOutgoingByIdQuery(id?: string) {
  return useQuery({
    queryKey: outgoingByIdQueryKey(id || ""),
    queryFn: () => {
      if (!id) throw new Error("No outgoing id provided");
      return outgoingRepository.getOutgoingById(id);
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
    gcTime: 60 * 60 * 1000,
    refetchOnMount: "always",
  });
}
